import Image from "next/image";
import { useRef, useState } from "react";
import AutoFitText from "./AutoFitText";
import { useTranslation } from "react-i18next";
import { CloseIcon, NewBackIcon, TopCloseIcon } from "@/components/icons";

interface TopAreaProps {
  currentStep: number;
  onClose: () => void;
  goEmailLogin: () => void;
  goRegistry: () => void;
  goSetPassword: () => void;
  goLogin: () => void;
  goVerifyCode: () => void;
  verifyCodeType: string;
}

const TopArea = ({
  currentStep,
  onClose,
  goEmailLogin,
  goRegistry,
  verifyCodeType,
}: TopAreaProps) => {
  const { t } = useTranslation();
  const config: Record<
    number,
    { title: string; back?: () => void; showLeft?: boolean }
  > = {
    20: {
      title: t("login.logIn"),
      showLeft: false,
    },
    21: {
      title: t("login.signUp"),
      back: goEmailLogin,
      showLeft: true,
    },
    22: {
      title: t("login.verifyEmail"),
      back: verifyCodeType == "1" ? goEmailLogin : goRegistry,
      showLeft: true,
    },
    23: {
      title: t("login.setPassword"),
      back: verifyCodeType == "1" ? goEmailLogin : goRegistry,
      showLeft: true,
    },
    24: {
      title: t("login.emailAlreadyRegistered"),
      back: goEmailLogin,
      showLeft: true,
    },
  };
  const containerRef = useRef<HTMLDivElement>(null);
  const [imageLoaded, setImageLoaded] = useState(false);
  const [displayText] = useState(
    <span>
      {t("login.loginTip")}
      <span className="text-[#A51634]"> 15GB </span> {t("login.cloudSpace")}
    </span>
  );

  if ([20, 21, 22, 23, 24].includes(currentStep)) {
    return (
      <div className="flex flex-row justify-between w-[100%] p-[16px] pb-[0]">
        <div className="w-[24px] h-[24px]">
          {config[currentStep].showLeft ? (
            <div onClick={config[currentStep].back}>
              <NewBackIcon></NewBackIcon>
            </div>
          ) : (
            ""
          )}
        </div>
        <div className="text-[18px] font-['Mulish'] font-[900] text-[#333]">
          <AutoFitText
            text={config[currentStep].title}
            maxFontSize={18}
            minFontSize={18}
          />
        </div>
        <div onClick={onClose} className="w-[24px] h-[24px]">
          <CloseIcon></CloseIcon>
        </div>
      </div>
    );
  }
  if (currentStep === 1) {
    return (
      <div className="flex flex-row justify-between w-[100%]">
        <div
          style={{
            marginTop: "-50px",
            // zIndex: 9999,
            position: "fixed",
            marginBottom: "-50%",
            width: "100%",
            display: "flex",
            flexDirection: "row",
            justifyContent: "center",
          }}
        >
          <div className="relative flex flex-col items-center justify-center">
            <Image
              src={"https://img.buscari.com/img/20250822-191740-topbanner.png"}
              alt="topbanner"
              width={0}
              height={0}
              style={{ width: "calc(100% - 32px)" }}
              onLoadingComplete={() => setImageLoaded(true)}
            ></Image>
            {imageLoaded && (
              <div
                ref={containerRef}
                style={{
                  position: "absolute",
                  paddingLeft: "25%",
                  paddingRight: "20%",
                  fontSize: "14px",
                  bottom: "8px",
                  fontWeight: "700",
                }} // 添加左侧 63px 的内边距，确保文字不会遮挡图片左侧
              >
                {displayText}
              </div>
            )}
          </div>
          <div
            style={{
              width: "24px",
              height: "24px",
              cursor: "pointer",
              position: "absolute",
              right: "12px",
              top: "-8px",
            }}
            onClick={onClose}
          >
            <TopCloseIcon></TopCloseIcon>
          </div>
        </div>
      </div>
    );
  }

  return null;
};
export default TopArea;
